package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.state.rememberOpsPaging
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.shared.ops.OpsUserRowDto
import dev.lingvo.site.ds.LFilterBar
import dev.lingvo.site.ds.LFilterField
import dev.lingvo.site.ds.LSearchField
import dev.lingvo.site.ds.LTable
import dev.lingvo.site.ds.LTableBody
import dev.lingvo.site.ds.LTableCell
import dev.lingvo.site.ds.LTableHead
import dev.lingvo.site.ds.LTableHeaderCell
import dev.lingvo.site.ds.LTableRow
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.formatUtc
import dev.lingvo.site.nav.UrlState
import org.jetbrains.compose.web.dom.Text

@Page("/users")
@Composable
fun UsersPage() {
    val ctx = rememberPageContext()
    var search by remember { mutableStateOf(UrlState.read(ctx, "q").orEmpty()) }
    OpsShell("Users") {
        val paging = rememberOpsPaging<OpsUserRowDto>(search)
        val resource = rememberOpsResource(search to paging.cursor) { (query, cursor) -> OpsApi.users(query.takeIf(String::isNotBlank), cursor) }
        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
            OpsPageHeader("Users", "Find an account, review its workspaces and inspect credential activity.", resource.state.isRefreshing, resource::refresh)
            LFilterBar(listOf(LFilterField("users-search", "Search", search.takeIf(String::isNotBlank), { search = ""; UrlState.replace(mapOf("q" to null)) }) { modifier -> LSearchField(search, { search = it; UrlState.replace(mapOf("q" to it)) }, modifier, "Search users", "Name or email", onCommit = {}) }), onClearAll = { search = ""; UrlState.replace(mapOf("q" to null)) })
            OpsPanel("Directory", "The directory is keyset-paged at 100 rows.") {
                OpsResourceStates(resource.state, "No users", "No user account has been recorded.", "No user matches this search.".takeIf { search.isNotBlank() }, retry = resource::refresh) { page ->
                    LTable(caption = "Operator user directory") {
                        LTableHead { LTableRow { listOf("Name", "Email", "Workspaces", "Verified", "Closing", "Created").forEach { LTableHeaderCell { Text(it) } } } }
                        LTableBody { page.rows.forEach { row -> LTableRow {
                            LTableCell { Link("/users/${row.userId}") { Text(row.name) } }
                            LTableCell { Text(row.email) }
                            LTableCell { Text(formatCount(row.workspaces)) }
                            LTableCell { Text(if (row.verified) "Yes" else "No") }
                            LTableCell { Text(formatUtc(row.closingAt, absent = "—")) }
                            LTableCell { Text(formatUtc(row.createdAt)) }
                        } } }
                    }
                }
                OpsResourcePagination(paging, resource.state, "users")
            }
        }
    }
}
